import styled from 'styled-components';
export var LogoWrapper = styled.div.withConfig({
  componentId: "a60coo-0"
})(["height:36px;img{height:100%;display:block;}"]);